/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { Card } from 'store/Card';
import { CardStatus, ICardDetails, IIdentity, IUser } from 'types';
import { IUserState } from '../types';
import { User } from './types';

const initialState: IUserState | null = null;

export const userReducer: Reducer<IUserState> = (state = initialState, action) => {
  switch (action.type) {
    case User.UPDATE_PAYMENT_NOTIFICATION_METHOD_SUCCESS:
    case User.GET_CURRENT_USER_SUCCESS: {
      const user = action.payload as IUser;

      // Do not overwrite card details if we already have them
      let cardDetail: ICardDetails = null;
      if (user.card?.id === state?.cardDetail?.id && state?.cardDetail?.network) {
        cardDetail = state.cardDetail;
      }

      return {
        ...user,
        cardDetail,
        invites: state?.invites || null,
      };
    }
    case User.UPDATE_IDENTITY_VERIFICATION_CODE_SUCCESS:
    case User.UPDATE_USER_PASSWORD_SUCCESS:
    case User.UPDATE_USER_NAME_SUCCESS:
    case User.UPDATE_CURRENT_USER_SUCCESS:
    case User.UPDATE_DATE_OF_BIRTH_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };

    case User.UPDATE_SMS_SUCCESS:
    case User.UPDATE_USER_EMAIL_SUCCESS:
      return {
        ...state,
        identities: [...(state?.identities || []), action.payload as IIdentity],
      };

    case User.GET_CURRENT_USER_CARD_SUCCESS: {
      const cardDetail = action.payload as ICardDetails;
      return {
        ...state,
        cardDetail,
      };
    }
    case Card.CREATE_TOKENIZED_CARD_SUCCESS:
    case Card.GET_CARD_SUCCESS:
      return {
        ...state,
        card: {
          ...state?.card,
          id: (action.payload as ICardDetails)?.id,
          status: CardStatus.ACTIVE,
        },
        cardDetail: action.payload as ICardDetails,
      };
    case Card.DELETE_CARD_SUCCESS:
      return {
        ...state,
        card: null,
        cardDetail: null,
      };
    case User.GET_USER_INVITES_SUCCESS: {
      return {
        ...state,
        invites: [...action.payload.invites],
      };
    }
    case User.ACCEPT_ALL_USER_INVITES_SUCCESS: {
      return {
        ...state,
        invites: action.payload,
      };
    }
    case User.CLEAR_USER_INVITES: {
      return {
        ...state,
        invites: null,
      };
    }
    case User.GET_USER_YEARLY_STATS_REQUEST: {
      return {
        ...state,
        yearlyStats: null,
      };
    }
    case User.GET_USER_YEARLY_STATS_SUCCESS: {
      return {
        ...state,
        yearlyStats: action.payload,
      };
    }
    case User.GET_USER_PENDING_AND_EXPIRED_PAYMENT_STATS_REQUEST: {
      return {
        ...state,
        pendingAndExpiredPaymentStats: null,
      };
    }
    case User.GET_USER_PENDING_AND_EXPIRED_PAYMENT_STATS_SUCCESS: {
      return {
        ...state,
        pendingAndExpiredPaymentStats: action.payload,
      };
    }
    case User.GET_USER_LATEST_PAYOUTS_REQUEST: {
      return {
        ...state,
        latestPayouts: null,
      };
    }
    case User.GET_USER_LATEST_PAYOUTS_SUCCESS: {
      return {
        ...state,
        latestPayouts: action.payload,
      };
    }
    case User.GET_USER_EXPIRED_PAYOUTS_REQUEST: {
      return {
        ...state,
        expiredPayouts: null,
      };
    }
    case User.GET_USER_EXPIRED_PAYOUTS_SUCCESS: {
      return {
        ...state,
        expiredPayouts: action.payload,
      };
    }
    case User.GET_USER_PENDING_PAYOUTS_REQUEST: {
      return {
        ...state,
        pendingPayouts: null,
      };
    }
    case User.GET_USER_PENDING_PAYOUTS_SUCCESS: {
      return {
        ...state,
        pendingPayouts: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
